module.exports = __webpack_public_path__ + "media/mabani/mabani-slide1-0e154f9d.jpg";